import React, { useState, useEffect, useCallback } from "react";
import {
  TopToolbar,
  RefreshButton,
  ReferenceField,
  TextField,
  SelectInput,
  DateField,
  ListButton,
  ShowButton,
  Edit,
  SimpleForm,
  SaveButton,
  Toolbar,
  useTranslate,
  useRecordContext,
  useGetOne,
  TextInput,
  NumberInput,
  required,
  useNotify,
  useRefresh,
  useRedirect,
} from "react-admin";
import Select from "react-select";
import {
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
  getLocalStorageKey,
} from "../common/common";
import { useLocation, useNavigate } from "react-router-dom";

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const EditActions = ({ basePath, data }) => (
  <TopToolbar>
    <RefreshButton />
    <ListButton basePath={basePath} />
    <ShowButton basePath={basePath} record={data} />
  </TopToolbar>
);

const EditTitle = ({ record }) => {
  return <span>Edit User {record ? `${record.first_name}` : ""}</span>;
};

const ClickItUserEdit = ({ permissions, ...props }) => {
  const [saleOffNameSapCode, setSaleOffNameSapCode] = useState([]);
  const [businessError, setBusinessError] = useState(false);
  const location = useLocation();
  const [originalList, setOriginalList] = useState([]);

  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [phoneErrorMsg, setPhoneErrorMsg] = useState(null);

  const [soldToError, setSoldToError] = useState(false);

  const path = location?.pathname.split("/");
  const { data } = useGetOne("users", { id: path[2] });
  let locale = getLocalStorageKey("locale");
  const [phoneNumber, setPhoneNumber] = useState(null || data?.phone);
  const businessData =
    data &&
    data?.businesses.map((item) => ({
      id: item.id,
      value: item.label,
      label: item.label,
      sap: item.sap_code,
    }));
  const [businessId, setBusinessId] = useState(businessData);
  console.log("businessId", data);

  useEffect(() => {
    setPhoneNumber(data?.phone);
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(`${apiUrl}/so_business_list?all_business_data=true`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        console.log("jsonD ===>", jsonD);
        let obj = {};
        obj.sap_order_materials = jsonD.data;
        obj.loadingShow = false;

        setOriginalList(
          obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap: item.sap_code,
          }))
        );

        setSaleOffNameSapCode(
          obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap: item.sap_code,
          }))
        );
      });
  }, []);
  console.log("umesh ===>", saleOffNameSapCode);
  const handleChange = (e) => {
    setSoldToError(false);
    // e.preventDefault();
    const arr = [...originalList];

    let result =
      arr &&
      arr.filter((item) => e && e.filter((i) => i.id === item.id).length === 0);
    if (e === null) {
      result = [...originalList];
      setBusinessId([]);
      // this.setState({ saleOffList: [] });
    }
    // console.log('result', result)
    setBusinessId(e);
    setSaleOffNameSapCode(result);
    // this.setState({
    //   saleOffList: e,
    //   saleOffNameSapCode: result

    // });
  };

  // const transform = (data) => ({
  //   ...data,
  //   businesses: businessId,
  // });

  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const onSuccess = (data) => {
    console.log("data =>", data);
    notify(`Changes saved`);
    // redirect('/posts');
    // refresh();
  };

  const PostEditToolbar = (props) => {
    console.log("umesh props", businessId);
    return (
      <Toolbar {...props}>
        <div className="so-save-button">
          <button disabled={!businessId} onClick={props.submitfun}>
            {" "}
            SAVE
          </button>
        </div>
      </Toolbar>
    );
  };

  const handleFormSubmit = (e) => {
    //   alert('submit');
    e.preventDefault();
    // if (phoneNumber === "" || phoneNumber === null) {
    //   setPhoneNumberError(true);
    //   setPhoneErrorMsg("Enter Phone number");
    // } else if (businessId.length === 0) {
    //   setSoldToError(true);
    // } else if (phoneNumber.length < 7 || phoneNumber.length > 15) {
    //   setPhoneNumberError(true);
    //   setPhoneErrorMsg("Phone number should be min 7 and max 15 digit");
    // } else {
    // setPhoneNumberError(false);
    // setSoldToError(false);
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    let req = {
      ...data,
      businesses: businessId,
    };
    console.log("req", req);
    options.method = "PATCH";
    options.body = JSON.stringify(req);
    fetch(`${apiUrl}//users/${data.id}`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        console.log("jsonD ===>", jsonD);
        // navigate("/terms_and_condition_list");
        if (jsonD.status === false) {
          notify(jsonD.message);
        } else {
          notify(jsonD.message);
          redirect("/users");
          refresh();
        }
      });
    // }
  };

  // const changePhoneNumber = (event) => {
  //   const pattern = new RegExp(/^[0-9\b]+$/);
  //   const reg = new RegExp("^d+$");
  //   // setSimilarNumberError(false);
  //   let positionObject = event.target.value;
  //   if (
  //     event.target.value === "" ||
  //     event.target.value === undefined ||
  //     event.target.value === null ||
  //     !event.target.value.trim().length ||
  //     reg.test(positionObject)
  //   ) {
  //     setPhoneNumberError(true);
  //     setPhoneErrorMsg("Enter Phone number");
  //   } else {
  //     setPhoneNumberError(false);
  //     setPhoneErrorMsg(null);
  //   }
  //   setPhoneNumber(positionObject);
  // };

  return (
    <Edit
      actions={<EditActions />}
      title={<EditTitle />}
      {...props}
      mutationMode="pessimistic"
      // transform={transform}
      // mutationMode='pessimistic'
      // mutationOptions={{ onSuccess }}
    >
      <SimpleForm
        toolbar={<PostEditToolbar submitfun={(e) => handleFormSubmit(e)} />}
      >
        <div className="ecu-select">
          <label className="select-label">
            Sold To
            <sup>*</sup>
          </label>
          <div className="select-retailer">
            <Select
              value={businessId}
              onChange={handleChange}
              options={saleOffNameSapCode}
              isMulti={true}
              source="businesses"
              required={true}
              IndicatorsContainer={true}
            />
            {soldToError && (
              <p className="so-input-error">Field cant be empty</p>
            )}
            {/* <button onClick={cancelClick}>
              {translate("resources.users.fields.clear")}
            </button> */}
          </div>
          {businessError && <p className="so-input-error">Enter Business Id</p>}
        </div>
        <div className="ecu-item-row">
          <div className="ecu-item">
            <label className="select-label">First name :</label>
            &nbsp;
            <TextField source="first_name" />
          </div>
          <div className="ecu-item">
            <label className="select-label">Last name :</label>
            &nbsp;
            <TextField source="last_name" />
          </div>
        </div>
        <div className="ecu-item-row">
          <div className="ecu-item">
            <label className="select-label">Created at :</label>
            &nbsp;
            <DateField
              // label={"Created at"}
              source="created_at"
              showTime
              options={{
                day: "numeric",
                month: "numeric",
                year: "numeric",
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              }}
            />
          </div>
          <div className="ecu-item">
            <label className="select-label">Updated at :</label>
            &nbsp;
            <DateField
              label={"Updated at"}
              source="updated_at"
              showTime
              options={{
                day: "numeric",
                month: "numeric",
                year: "numeric",
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              }}
            />
          </div>
        </div>
        {/* <label className="select-label">
        {" "}
        {translate("resources.users.fields.phone")}{" "}
      </label> */}

        <div className="ecu-item">
          <label className="select-label">Phone number :</label>
          &nbsp;
          <TextField source="phone" />
        </div>

        {/* <TextField source="phone" /> */}
        <div className="ecu-item-row">
          {/* <div className="ecu-item">
          <div className="so-input ecu-phone">
          <label>
            Phone number
            <sup>*</sup>
          </label>
          <input
            type="number"
            min="7"
            disabled
            maxLength="18"
            value={phoneNumber}
            onChange={changePhoneNumber}
          />
          {phoneNumberError && (
            <p className="so-input-error">{phoneErrorMsg}</p>
          )}

          {similarNumberError && (
          <p className="so-input-error">{similarNumberMsg}</p>
        )}
        </div>
        </div> */}
          <div className="ecu-item">
            <SelectInput
              source="status"
              choices={[
                { id: true, name: "True" },
                { id: false, name: "False" },
              ]}
              defaultValue="status"
              validate={required()}
            />
          </div>
          {locale == "ar-EG" && (
            <div className="ecu-item">
              <SelectInput
                source="is_payment_enable"
                choices={[
                  { id: true, name: "True" },
                  { id: false, name: "False" },
                ]}
                defaultValue="is_payment_enable"
                validate={required()}
                label="Payment available"
              />
            </div>
          )}
        </div>
      </SimpleForm>
    </Edit>
  );
};

export default ClickItUserEdit;
